import { Menu, MenuItem } from "@blueprintjs/core";
import { useOrg } from "../auth/OrgContext";
import { useProjects } from "../auth/ProjectContext";
import { useLocation, useNavigate } from "react-router-dom";

export default function AccountSidebar() {
  const { orgs } = useOrg();
  const { projects } = useProjects();
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path: string) => location.pathname === path;

  return (
    <Menu>
      <MenuItem icon="user" text="Profile" onClick={() => navigate("/account")} active={isActive("/account")} />
      <MenuItem icon="credit-card" text="Subscription" onClick={() => navigate("/account/subscription")} active={isActive("/account/subscription")} />
      <MenuItem icon="chat" text="Chat Log" onClick={() => navigate("/account/chat-log")} active={isActive("/account/chat-log")} />
      <MenuItem icon="office" text="Organizations" onClick={() => navigate("/account/organizations")} active={isActive("/account/organizations") || location.pathname.startsWith("/organizations/")} />
      {orgs.map((org) => (
        <MenuItem
          key={org.id}
          text={org.name}
          icon="office"
          style={{ paddingLeft: 32 }}
          onClick={() => navigate(`/organizations/${org.id}`)}
          active={location.pathname === `/organizations/${org.id}`}
        />
      ))}
      <MenuItem icon="folder-open" text="Projects" onClick={() => navigate('/account/projects')} active={isActive("/account/projects") || location.pathname.startsWith("/account/projects/")} />
      {projects.map((p) => (
        <MenuItem
          key={p.id}
          text={p.name}
          icon="briefcase"
          style={{ paddingLeft: 32 }}
          onClick={() => navigate(`/account/projects/${p.id}`)}
          active={location.pathname === `/account/projects/${p.id}`}
        />
      ))}
    </Menu>
  );
}

